module.exports = __webpack_public_path__ + "static/media/sf-test-17.1d0f3391.mp3";